import StoreConfig from '@/config';
import { websiteEnv } from './website-env';

export const browserStore = {
  // 西班牙语共用站点
  isSpain: websiteEnv.isSpain && StoreConfig.store_code === 'es',
  isMexico: websiteEnv.isSpain && StoreConfig.store_code === 'mx',

  // 德语共用站点
  isGermany: websiteEnv.isGermany && StoreConfig.store_code === 'de',
  isSwitzerland: websiteEnv.isGermany && StoreConfig.store_code === 'ch',
  isAustria: websiteEnv.isGermany && StoreConfig.store_code === 'at',

  // 荷兰语共用站点
  isNetherlands: websiteEnv.isNetherlands && StoreConfig.store_code === 'nl',
  isBelgium: websiteEnv.isNetherlands && StoreConfig.store_code === 'be',
};
